var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconsEditAltBlue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 18,
    viewBox: "0 0 19 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.7837 5.55078C15.0672 5.26728 15.2232 4.89078 15.2232 4.49028C15.2232 4.08978 15.0672 3.71328 14.7837 3.42978L13.5942 2.24028C13.3107 1.95678 12.9342 1.80078 12.5337 1.80078C12.1332 1.80078 11.7567 1.95678 11.474 2.23953L3.5 10.1888V13.5H6.80975L14.7837 5.55078ZM12.5337 3.30078L13.724 4.48953L12.5315 5.67753L11.342 4.48878L12.5337 3.30078ZM5 12V10.8113L10.28 5.54778L11.4695 6.73728L6.19025 12H5ZM3.5 15H15.5V16.5H3.5V15Z",
    fill: "#0086D6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconsEditAltBlue);
export default __webpack_public_path__ + "static/media/icons-edit-alt-blue.1bfede1c1772eef598f1f267d3944a5a.svg";
export { ForwardRef as ReactComponent };